import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgOppHeart = (props) => /* @__PURE__ */ _jsx("svg", {
	height: "100px",
	width: "100px",
	fill: "#379b75",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 100 100",
	enableBackground: "new 0 0 100 100",
	xmlSpace: "preserve",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M81.989502,16.511982c-11.4181747-5.2832279-26.3520966-0.3137932-31.6353264,11.0787659  c-5.283226-11.3925591-20.2171497-16.3683987-31.6353264-11.0787678  C6.5578213,22.1538277,0.7430693,36.5626297,10.348938,53.5586128  c6.3349743,11.2364006,17.2171555,19.8980751,35.6385612,34.1655846c2.5703621,1.9907608,6.163044,1.9907379,8.7333527-0.0000839  c18.4214058-14.2682724,29.3035927-22.9350433,35.6385689-34.1655006  C99.9652863,36.5626297,94.1505356,22.1538277,81.989502,16.511982z" })
});
export default SvgOppHeart;
